import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { SendPostRequest } from "../http";
import Spinner from "./Spinner";
import { useSelector } from "react-redux";
import { formatDate } from "../Helper/Helper";

export default function BlogDetail() {
  const { id } = useParams();
  const { slug } = useParams();
  const [servicesDetail, setServicesDetail] = useState({});
  const [servicesList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(true);

  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesDetail();
  }, [slug]);

  const getServicesDetail = async () => {
    try {
      setLoading(true);
      const response = await SendPostRequest("blogs/detail", {
        slug: slug,
      });

      if (response.status === "success") {
        setServicesList(response?.data?.lists);
        setServicesDetail(response?.data?.detail);
      } else {
        console.warn("No service detail found in the response.");
      }
    } catch (error) {
      console.error("Error fetching services detail:", error);
    } finally {
      setLoading(false);
    }
  };

  const [backgroundImage, setBackgroundImage] = useState("");
  useEffect(() => {
    let themeColor;
    if (sitedata) {
      themeColor = sitedata?.theme_color?.split(".css").join("");
    } else {
    }

    setBackgroundImage(`/assets/img/doctors/banner_bg_${themeColor}.svg`);
  }, [sitedata?.theme_color]);

  return (
    <>
      <Header />
      <section
        className="cs_banner cs_style_5 cs_bg_filed"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="container">
          <div className="">
            <h2 className="cs_banner_title cs_fs_65">
              {servicesDetail?.title}
            </h2>
          </div>
        </div>
      </section>
      <div className="container">
        <ol className="breadcrumb"></ol>
        <div className="cs_height_35"></div>
        <div className="cs_height_20"></div>
        <div className="row">
          <div className="col--lg-8 col-md-8 col-12 mobile_view_blogs">
            {loading ? (
              <div className="d-flex align-items-center justify-content-center">
                <Spinner />
              </div>
            ) : (
              <>
                <div
                  style={{
                    backgroundImage: `url(${servicesDetail?.image_url})`,
                    backgroundPosition: "top center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    borderRadius: "20px",
                    height: "500px",
                  }}
                ></div>
                {/* <img
                  src={servicesDetail?.image_url}
                  alt="Blog Details"
                  className=" cs_radius_20 services-detail-img mb-4"
                /> */}

                <div class="author_detail_heading-wrapper mb-4">
                  <h3>
                    {servicesDetail?.author_slug &&
                      servicesDetail?.author_name && (
                        <Link
                          to={`/author/detail/${servicesDetail?.author_slug}`}
                        >
                          Author: {servicesDetail?.author_name}
                        </Link>
                      )}
                  </h3>
                  <div class="cs_posted_by">
                    {formatDate(servicesDetail?.date)}
                  </div>
                </div>

                <div className="cs_blog_details">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: servicesDetail?.content,
                    }}
                  />
                </div>
                <div className="cs_height_92"></div>
              </>
            )}
          </div>
          <div className="col-lg-4 col-md-4 d-none d-lg-block">
            <div className="cs_sidebar">
              <div className="cs_sidebar_item blogs-detail-list">
                <h2 className="cs_sidebar_widget_title">Other Blogs</h2>
                {loading ? (
                  <div className="d-flex align-items-center justify-content-center">
                    <Spinner />
                  </div>
                ) : servicesList?.length > 0 ? (
                  <ul>
                    {servicesList?.map((list, index) => (
                      <li key={index}>
                        <div className="blogs_right_listing">
                          <div
                            style={{
                              backgroundImage: `url(${list?.image})`,
                              backgroundPosition: "top center",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                              borderRadius:"10px",
                              height: "80px",
                              minWidth: "80px",
                              
                            }}
                          ></div>
                          {/* <img src={list?.image} alt="blog" /> */}
                          <Link to={`/blog/detail/${list?.slug}`}>
                            {list?.title}
                          </Link>
                        </div>

                        <div class="author_heading-wrapper">
                          {list?.author_slug && list?.author_name && (
                            <>
                              <p>Author:</p>
                              <Link to={`/author/detail/${list?.author_slug}`}>
                                <p>{list?.author_name}</p>
                              </Link>
                            </>
                          )}
                        </div>
                        {list?.date && (
                          <div className="blogdetail_sidebar_date mb-4">
                            <p>Publish Date:</p>
                            <span>{formatDate(list?.date)}</span>
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No other blogs found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_height_42 cs_height_xl_25"></div>
      <Footer />
    </>
  );
}
